/* @flow */

export default {
  root: {
    width: '100%',
    display: 'flex',
    gap: '10px',
  },
};
